if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', handleLayout);
} else {
  handleLayout();
}

function randomAB(percentage) {
  const threshold = percentage / 100; 
  const rand = Math.random();
  if (rand < threshold) {
    return 'a';
  } else {
    return 'b'; 
  }
}

function calc(storage) {
  let layout = randomAB(60)

  storage.set('layout', layout);
  return layout
}

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) return value;
  }
  return null;
}


const postData = async (ip, aOrB, source) => {
  return;
  let session = sessionStorage.getItem("tracking_id") 
  const url = 'https://api.summitmetalsdistribution.com/supa/process'
  const data = {
    ip: ip,
    a_or_b: aOrB,
    session: session,
    source: source
  };

  const response = await fetch(url, {
    method: 'POST', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Specify the content type
    },
    body: JSON.stringify(data), // Convert object to JSON string
  });

  const json = await response.json()

  if (json.id){
    sessionStorage.setItem("tracking_id", json.id)
  }
};


async function handleChange(event){
  return;
  let session = sessionStorage.getItem("tracking_id") 
  if (session === null) return

  const url = 'https://api.summitmetalsdistribution.com/supa/update'
  const data = {
    id: session,
    field: event,
    value: true
  };

  await fetch(url, {
    method: 'POST', // HTTP method
    headers: {
      'Content-Type': 'application/json', // Specify the content type
    },
    body: JSON.stringify(data), // Convert object to JSON string
  });
}

function handleLayout() {
  if (document.readyState === 'loading') return;

  const storage = window.BtStorageUtil || {
    get: key => localStorage.getItem(key),
    set: (key, value) => localStorage.setItem(key, value)
  };

  //let layout = storage.get('layout');
  let layout = 'a'
  if (layout && layout !== 'a' && layout !== 'b') {
    layout = calc(storage);
  }
  if (!layout) {
    layout = calc(storage)
  }
  let source = null

  const urlParams = new URLSearchParams(window.location.search);
  source = urlParams.get('source');
  if (source) {
    const url = new URL(window.location.href);
    url.searchParams.delete('source');
    window.history.replaceState({}, '', url);
  }

  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(async (data)=> {
      postData(data.ip, layout, source)
    });


  document.querySelectorAll('[data-layout]').forEach(element => {
    element.style.display = 'none';
  });

  document.querySelectorAll(`[data-layout="${layout}"]`).forEach(element => {
    element.style.display = element.dataset.layoutDisplay || 'block';
  });
}